import { styled } from '@components-shared/src/stitches';

const TABLET_MAX_DESCRIPTION_HEIGHT = 64;
const TABLET_MAX_DESCRIPTION_HEGIHT_LONG_TITLE = 51;
export const MOBILE_MAX_DESCRIPTION_HEIGHT = 80;
export const MOBILE_MAX_DESCRIPTION_HEIGHT_LONG_TITLE = 64;
export const DESCRIPTION_CHAR_MAX = 288;

export const CardContainer = styled('div', {
  display: 'flex',
  width: 254,
  padding: '6px 6px 12px 4px',
  '@tablet': {
    padding: '20px 6px 20px 4px',
  },
});

export const Container = styled('div', {
  margin: '0 auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  width: '100%',
  paddingLeft: 16,
  marginTop: 32,
  gap: 16,
  '@tablet': {
    paddingX: 24,
    marginTop: 64,
  },
});

export const RewardsContainer = styled('div', {
  display: 'none',
  height: '100%',

  '@tablet': {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(1, 1fr)',
    gap: 12,
  },
  '@laptop': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  '@desktop': {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
});

export const RewardCardContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: 266,
  height: 194,
  overflow: 'hidden',
  padding: '8px 12px 12px',
  backgroundColor: '#fff',
  boxShadow: '0px 6px 16px 1px rgba(0, 0, 0, 0.08)',
  borderRadius: 8,

  p: {
    base: 'S',
    fontStyle: 'regular',
  },

  '@tablet': {
    width: '100%',
    height: 198,
    gap: 6,
  },
});

export const Wrapper = styled('div', {
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  gap: 12,
});

export const Header = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
});

export const Title = styled('h2', {
  base: 'M',
  color: '#000',
  fontStyle: 'semibold',
});

export const Description = styled('div', {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',

  '@tablet': {
    height: 'max-content',
    maxHeight: `${TABLET_MAX_DESCRIPTION_HEIGHT}px`,
  },
  variants: {
    isLongTitle: {
      true: {
        '-webkit-line-clamp': 4,
        '@tablet': {
          maxHeight: `${TABLET_MAX_DESCRIPTION_HEGIHT_LONG_TITLE}px`,
        },
      },
      false: {
        '-webkit-line-clamp': 5,
        '@tablet': {
          '-webkit-line-clamp': 4,
          maxHeight: `${TABLET_MAX_DESCRIPTION_HEIGHT}px`,
        },
      },
    },
  },
});

export const Overflow = styled('div', {
  display: 'flex',
  position: 'absolute',
  width: 115,
  height: 16,
  bottom: 0,
  right: 0,
});

export const Ellipsis = styled('div', {
  whiteSpace: 'nowrap',
  margin: '0 0 0 auto',
  width: 'fit-content',
  cursor: 'pointer',
  p: {
    color: '#000',
    textDecoration: 'underline',
  },
});

export const RewardImageContainer = styled('div', {
  height: 50,
  width: 50,

  svg: {
    height: 50,
    width: 50,
  },

  '@tablet': {
    left: 12,
  },
});

export const GoldenEggWinner = styled('div', {
  display: 'flex',
  width: 'fit-content',
  height: 20,
  h5: {
    base: 'S',
  },

  variants: {
    revealed: {
      true: {
        alignItems: 'end',
        h5: {
          color: '$neutral400',
        },
      },
      false: {
        alignItems: 'center',
        background: '$neutral200',
        color: '$neutral900',
        fontWeight: 500,
        paddingX: 10,
        borderRadius: 4,
      },
    },
  },

  p: {
    base: 'S',
    maxWidth: 100,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '@tablet': {
      maxWidth: 150,
    },
  },

  '.not-revealed': {
    fontStyle: 'medium',
  },
});

export const MAX_CHARS = DESCRIPTION_CHAR_MAX;

export const getMaxHeight = ({
  titleType,
  tablet,
}: {
  titleType: 'short' | 'long';
  tablet: boolean;
}) => {
  const shortTitleHeight = tablet ? TABLET_MAX_DESCRIPTION_HEIGHT : MOBILE_MAX_DESCRIPTION_HEIGHT;

  const longTitleHeight = tablet
    ? TABLET_MAX_DESCRIPTION_HEGIHT_LONG_TITLE
    : MOBILE_MAX_DESCRIPTION_HEIGHT_LONG_TITLE;

  return titleType === 'short' ? shortTitleHeight : longTitleHeight;
};

export type RewardType = {
  icon: React.ReactNode;
  title: string;
  description: string;
};
